var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import WixComponent from '../BaseComponents/WixComponent';

import styles from './Loader.scss';

var Loader = function (_WixComponent) {
  _inherits(Loader, _WixComponent);

  function Loader() {
    _classCallCheck(this, Loader);

    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
  }

  _createClass(Loader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          color = _props.color,
          text = _props.text;

      var className = classnames(styles.loader, styles[size], styles[color]);
      return React.createElement(
        'div',
        { className: className },
        React.createElement('div', { className: styles.wheel }),
        text && React.createElement(
          'div',
          { className: styles.text },
          text
        )
      );
    }
  }]);

  return Loader;
}(WixComponent);

Loader.defaultProps = {
  size: 'medium',
  color: 'blue'
};

Loader.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
  color: PropTypes.oneOf(['blue', 'white']).isRequired,
  text: PropTypes.string
};

export default Loader;
//# sourceMappingURL=Loader.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Loader/Loader.js